import axios from "axios";

export const deleteDeadline = async (date: string) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API}/Settings/deadline?Date=${date}`
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
